<span [class]="'processing-badge status-' + state?.code">{{ state | localizedSupplychain : 'state' }} </span>
